/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  Divider,
  Flex,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Option,
  OverflowTooltip,
  Select,
  Scrollbar,
  Space,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  TableScrollbar,
  Text,
  Truncate,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { AddIcon, ArrowDownIcon, DeleteIcon } from '@tonic-one/react-icons';
import { Formik, Form, useField, FormikProps } from 'formik';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabel, TitleLabel } from 'src/components/Common/FormComponent';
import { InputFormik } from 'src/components/Common/FormikComponent';
import {
  BuildingBlock,
  BuildingBlockTypeEnum,
  DlpOperatorEnum,
  DlpTemplateDetail,
  DpBuiltinEnum,
  TableColumn,
  TemplateRule,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { useDlpTemplateDetailStore } from './store';
import isEqual from 'lodash/isEqual';
import { useDlpConditionStatementStyle } from './style';
import IconButton from '../../../../../components/IconButton';
import { usePermissionStore } from '../../../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';

export interface DlpTemplateModalProps {
  isVisible: boolean;
  onClose: () => void;
  initialState: DlpTemplateDetail;
  onSave: (config: DlpTemplateDetail) => void;
}
export const ConditionStatement = () => {
  const { t } = useTranslation();
  const expressionList = useDlpTemplateDetailStore(
    (s) => s.expressionList,
    isEqual
  );
  const keywordList = useDlpTemplateDetailStore((s) => s.keywordList, isEqual);
  const buildingBlockList = useDlpTemplateDetailStore(
    (s) => s.buildingBlockList,
    isEqual
  );
  const setBuildingBlock = useDlpTemplateDetailStore((s) => s.setBuildingBlock);
  const addNewBuildingBlock = useDlpTemplateDetailStore(
    (s) => s.addNewBuildingBlock
  );
  const clearBuildingBlock = useDlpTemplateDetailStore(
    (s) => s.clearBuildingBlock
  );
  const deleteSpecificBuildingBlock = useDlpTemplateDetailStore(
    (s) => s.deleteSpecificBuildingBlock
  );
  // local state
  // const [buildingBlockList, setBuildingBlockList] = React.useState<
  //   BuildingBlock[]
  // >([]);
  // const setBuildingBlock = useCallback(
  //   (index: number, payload: Partial<BuildingBlock>) => {
  //     if (index >= buildingBlockList.length) {
  //       return;
  //     }
  //     const newBuildingBlockList = [...buildingBlockList];
  //     newBuildingBlockList[index] = {
  //       ...newBuildingBlockList[index],
  //       ...payload,
  //     };
  //     setBuildingBlockList(newBuildingBlockList);
  //   },
  //   [buildingBlockList]
  // );
  // const deleteLastBuildingBlock = useCallback(() => {
  //   if (buildingBlockList.length === 0) {
  //     return;
  //   }
  //   const newBuildingBlockList = [...buildingBlockList];
  //   newBuildingBlockList.pop();
  //   setBuildingBlockList(newBuildingBlockList);
  // }, [buildingBlockList]);
  const columns: TableColumn[] = React.useMemo(
    () => [
      {
        id: 'sourceType',
        header: 'Data identifier type',
        cell: (row: any, rowIndex: number) => {
          return (
            <Select
              value={row.sourceType}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setBuildingBlock(rowIndex, {
                  sourceType: e.target.value as BuildingBlockTypeEnum,
                });
              }}
            >
              <Option
                value={BuildingBlockTypeEnum.entity}
                key={BuildingBlockTypeEnum.entity}
              >
                {t('policy.modal.complianceTemplate.expressions')}
              </Option>
              <Option
                value={BuildingBlockTypeEnum.keyword}
                key={BuildingBlockTypeEnum.keyword}
              >
                {t('policy.modal.complianceTemplate.keywordLists')}
              </Option>
            </Select>
          );
        },
        size: 155,
      },
      {
        id: 'displayName',
        header: 'Data identifier name',
        cell: (row: any, rowIndex: number) => {
          return (
            <Select
              value={row.sourceName}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                const sourceName = e.target.value;
                let displayName;
                if (row.sourceType === BuildingBlockTypeEnum.entity) {
                  displayName = expressionList.find(
                    (expression) =>
                      expression.dpExpressionInternalname === sourceName
                  )?.dpExpressionName;
                }
                if (row.sourceType === BuildingBlockTypeEnum.keyword) {
                  displayName = keywordList.find(
                    (keyword) => keyword.dpKeywordInternalname === sourceName
                  )?.dpKeywordName;
                }
                if (!displayName) {
                  console.error('something wrong');
                } else {
                  setBuildingBlock(rowIndex, {
                    sourceName: e.target.value,
                    displayName,
                  });
                }
              }}
            >
              {row.sourceType === BuildingBlockTypeEnum.entity
                ? expressionList.map((expression) => (
                    <Option
                      value={expression.dpExpressionInternalname}
                      key={expression.cfgIndex}
                    >
                      {expression.dpExpressionName}
                    </Option>
                  ))
                : keywordList.map((keyword) => (
                    <Option
                      value={keyword.dpKeywordInternalname}
                      key={keyword.cfgIndex}
                    >
                      {keyword.dpKeywordName}
                    </Option>
                  ))}
            </Select>
          );
        },
        size: 470,
      },
      {
        id: 'entityHits',
        header: 'Ocuurences',
        cell: (row: any, rowIndex: number) => {
          if (row.sourceType === BuildingBlockTypeEnum.entity) {
            return (
              <Input
                type="number"
                maxLength={4}
                value={row.entityHits + ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  if (e.target.value === '') {
                    setBuildingBlock(rowIndex, {
                      entityHits: 0,
                    });
                    return;
                  }
                  const num = parseInt(e.target.value);
                  if (!isNaN(num)) {
                    setBuildingBlock(rowIndex, {
                      entityHits: Math.min(Math.max(num, 1), 9999),
                    });
                  }
                }}
                onBlur={(e: any) => {
                  if (e.target.value === '0') {
                    setBuildingBlock(rowIndex, {
                      entityHits: 1,
                    });
                  }
                }}
              />
            );
          } else {
            return null;
          }
        },
        size: 100,
      },
      {
        id: 'deleteAction',
        header: 'Delete',
        cell: (row: any, rowIndex: number) => {
          return (
            <IconButton
              onClick={() => {
                deleteSpecificBuildingBlock(rowIndex);
              }}
              disabled={rowIndex === 0}
            >
              <Icon as={DeleteIcon}></Icon>
            </IconButton>
          );
        },
        size: 40,
      },
    ],
    []
  );
  const rows = React.useMemo(() => {
    return buildingBlockList.map((row, rowIndex) => {
      return {
        id: rowIndex,
        cells: columns.map((column: TableColumn, columnIndex: number) => {
          return {
            id: `${columnIndex}_${column.id}`,
            column,
            row,
          };
        }),
        row,
      };
    });
  }, [buildingBlockList, columns]);
  const {
    tableStyleProps,
    tableHeaderStyleProps,
    hoverBackgroundColor,
    descriptionColor,
    cellHeight,
    headerHeight,
    templateTableMaxHeight,
    clearButtonColor,
  } = useDlpConditionStatementStyle();
  const tableHeight = useMemo(() => {
    //temp ignore header
    // const height = headerHeight + buildingBlockList.length * cellHeight;
    const height = 20 + buildingBlockList.length * cellHeight;
    const result =
      height > templateTableMaxHeight ? templateTableMaxHeight : height;
    return result;
  }, [buildingBlockList]);

  return (
    <Flex direction="column">
      <TitleLabel
        title={t('policy.modal.complianceTemplate.ruleDefinitions')}
        fontWeight="600"
        fontSize="18px"
        lineHeight="24px"
      ></TitleLabel>
      <TitleLabel
        title={t('policy.modal.complianceTemplate.ruleDefinitionsDesc')}
        fontSize="14px"
        lineHeight="20px"
        color={descriptionColor}
        mt="8px"
        mb="12px"
      ></TitleLabel>
      <Table
        layout="flexbox"
        variant="default"
        size="md"
        {...tableStyleProps}
        height={tableHeight}
      >
        {/* <TableHeader {...tableHeaderStyleProps}>
          <TableHeaderRow>
            {columns.map((column) => {
              const styleProps = {
                flex: 'none',
                width: column.size,
                ...column.style,
              };
              return (
                <TableHeaderCell key={column.id} {...styleProps}>
                  <Truncate>{column.header}</Truncate>
                </TableHeaderCell>
              );
            })}
          </TableHeaderRow>
        </TableHeader> */}
        <TableScrollbar
          maxHeight="200px"
          overflow="visible" // Make the scrollbar visible
          overflowX="hidden"
        >
          <TableBody>
            {rows.map((row) => {
              const styleProps = {
                _hover: {
                  backgroundColor: hoverBackgroundColor,
                },
              };
              return (
                <TableRow key={row.id} {...styleProps}>
                  {row.cells.map((cell, cellIndex) => {
                    const styleProps = {
                      flex: 'none',
                      width: cell.column.size,
                      ...cell.column.style,
                    };
                    return (
                      <TableCell key={cell.id} {...styleProps}>
                        {typeof cell.column.cell === 'function' ? (
                          cell.column.cell(row.row, row.id)
                        ) : (
                          <Truncate>
                            {
                              cell.row[
                                cell.column.accessorKey as keyof typeof cell.row
                              ]
                            }
                          </Truncate>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </TableScrollbar>
      </Table>
      <Stack
        direction="row"
        shouldWrapChildren={true}
        spacing="8px"
        mt="12px"
        ml="6px"
      >
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="secondary"
          onClick={addNewBuildingBlock}
        >
          <Icon as={AddIcon} />
        </Button>
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="ghost"
          onClick={clearBuildingBlock}
          color={clearButtonColor}
        >
          <Icon as={DeleteIcon} />
          {t('common.action.label.clear')}
        </Button>
      </Stack>
    </Flex>
  );
};
export const TemplateDefinition = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  // get from store
  const buildingBlockList = useDlpTemplateDetailStore(
    (s) => s.buildingBlockList,
    isEqual
  );
  const clearBuildingBlock = useDlpTemplateDetailStore(
    (s) => s.clearBuildingBlock
  );
  // get from form
  const [field, meta, helpers] = useField(name);
  const { value, error, touched } = meta;
  const { setValue } = helpers;
  // style
  const {
    descriptionColor,
    tableStyleProps,
    tableHeaderStyleProps,
    headerHeight,
    cellHeight,
    templateTableMaxHeight,
    hoverBackgroundColor,
  } = useDlpConditionStatementStyle();
  const tableHeight = useMemo(() => {
    const height = headerHeight + value.length * cellHeight;
    const result =
      height > templateTableMaxHeight ? templateTableMaxHeight : height;
    return result;
  }, [value]);
  // local state
  const handleAddToTemplate = useCallback(() => {
    const newMatchRule = [...value];
    newMatchRule.push({
      buildingBlock: buildingBlockList,
      operation: DlpOperatorEnum.and,
    });
    setValue(newMatchRule);
    clearBuildingBlock();
  }, [buildingBlockList, value]);
  const handleSetOperator = useCallback(
    (index: number, operator: DlpOperatorEnum) => {
      const newMatchRule = [...value];
      newMatchRule[index].operation = operator;
      setValue(newMatchRule);
    },
    [value]
  );

  const handleRemoveTemplate = useCallback(
    (index: number) => {
      const copyValue = [...value];
      copyValue.splice(index, 1);
      setValue(copyValue);
    },
    [value]
  );

  // table
  const templateRules: { operator: DlpOperatorEnum; definition: string }[] =
    useMemo(() => {
      if (value.length === 0) {
        return [];
      }
      const result = value.map((rule: TemplateRule) => {
        const buildingBlockLength = rule.buildingBlock.length;

        const definition = rule.buildingBlock.reduce(
          (acc: string, cur: BuildingBlock, index: number) => {
            const prefix = acc ? acc : `${acc} `;
            const name = cur.displayName;
            const operator = 'AND';
            const hits =
              cur.sourceType === BuildingBlockTypeEnum.entity
                ? `(${cur.entityHits})`
                : '';
            const contetn = `${prefix}${name}${hits}`;
            if (index === buildingBlockLength - 1) {
              return contetn;
            } else {
              return `${contetn} ${operator} `;
            }
          },
          ''
        );
        return {
          definition,
          operation: rule.operation,
        };
      });
      return result;
    }, [value]);

  const columns: TableColumn[] = React.useMemo(
    () => [
      {
        id: 'operation',
        header: 'Operator',
        cell: (row: any, rowIndex: number) => {
          if (rowIndex === 0) {
            return (
              <Select
                value={row.operation}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  handleSetOperator(
                    rowIndex,
                    e.target.value as DlpOperatorEnum
                  );
                }}
              >
                <Option value={DlpOperatorEnum.none} key="none" />
                <Option
                  value={DlpOperatorEnum.except}
                  key={DlpOperatorEnum.except}
                >
                  EXCEPT
                </Option>
              </Select>
            );
          }
          return (
            <Select
              value={row.operation}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                handleSetOperator(rowIndex, e.target.value as DlpOperatorEnum);
              }}
            >
              <Option value={DlpOperatorEnum.and} key={DlpOperatorEnum.and}>
                AND
              </Option>
              <Option value={DlpOperatorEnum.or} key={DlpOperatorEnum.or}>
                OR
              </Option>
              <Option
                value={DlpOperatorEnum.except}
                key={DlpOperatorEnum.except}
              >
                EXCEPT
              </Option>
            </Select>
          );
        },
        size: 155,
      },
      {
        id: 'definition',
        header: 'Definition',
        accessorKey: 'definition',
        size: 500,
      },
      {
        id: 'deleteAction',
        header: 'Delete',
        cell: (row: any, rowIndex: number) => {
          return (
            <IconButton
              onClick={() => {
                handleRemoveTemplate(rowIndex);
              }}
            >
              <Icon as={DeleteIcon}></Icon>
            </IconButton>
          );
        },
        size: 100,
      },
    ],
    [value]
  );
  const rows = React.useMemo(() => {
    return templateRules.map((row, rowIndex: number) => {
      return {
        id: rowIndex,
        cells: columns.map((column: TableColumn, columnIndex: number) => {
          return {
            id: `${columnIndex}_${column.id}`,
            column,
            row,
          };
        }),
        row,
      };
    });
  }, [templateRules, columns]);

  const popperProps = { usePortal: true };

  return (
    <Flex direction="column" mt="16px">
      <Stack direction="row" shouldWrapChildren={true} mb="16px" pl="4px">
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="secondary"
          onClick={handleAddToTemplate}
        >
          <Icon as={ArrowDownIcon} />
          {t('common.action.label.add')}
        </Button>
      </Stack>
      <Divider mt="10px" mb="10px" />
      <TitleLabel
        title={t('policy.modal.complianceTemplate.templateRules')}
        fontWeight="600"
        fontSize="18px"
        lineHeight="24px"
      ></TitleLabel>
      {templateRules.length === 0 ? (
        <TitleLabel
          title={t('policy.modal.complianceTemplate.noneDefined')}
          fontSize="14px"
          lineHeight="20px"
          color={descriptionColor}
          mt="8px"
          mb="12px"
        ></TitleLabel>
      ) : (
        <Table
          layout="flexbox"
          variant="default"
          size="sm"
          {...tableStyleProps}
          height={tableHeight}
        >
          {/* <TableHeader {...tableHeaderStyleProps}>
          <TableHeaderRow>
            {columns.map((column) => {
              const styleProps = {
                flex: 'none',
                width: column.size,
                ...column.style,
              };
              return (
                <TableHeaderCell key={column.id} {...styleProps}>
                  <Truncate>{column.header}</Truncate>
                </TableHeaderCell>
              );
            })}
          </TableHeaderRow>
        </TableHeader> */}
          <TableScrollbar
            maxHeight="200px"
            overflow="visible" // Make the scrollbar visible
          >
            <TableBody width="98%">
              {rows.map((row) => {
                const styleProps = {
                  _hover: {
                    backgroundColor: hoverBackgroundColor,
                  },
                };
                return (
                  <TableRow key={row.id} {...styleProps} height="44px">
                    {row.cells.map((cell, cellIndex) => {
                      const styleProps = {
                        display: 'flex',
                        width: cell.column.size,
                        ...cell.column.style,
                        alignItems: 'center',
                      };
                      if (typeof cell.column.cell === 'function') {
                        return (
                          <TableCell key={cell.id} {...styleProps}>
                            {cell.column.cell(row.row, row.id)}
                          </TableCell>
                        );
                      }
                      const content =
                        cell.row[
                          cell.column.accessorKey as keyof typeof cell.row
                        ];
                      return (
                        <TableCell key={cell.id} {...styleProps}>
                          <OverflowTooltip
                            PopperProps={popperProps}
                            label={content}
                          >
                            {content}
                          </OverflowTooltip>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </TableScrollbar>
        </Table>
      )}
    </Flex>
  );
};
const DlpTemplateModal = React.memo((props: DlpTemplateModalProps) => {
  const { widthEditablePermission } = usePermissionStore();
  const dlpEditPermission = widthEditablePermission(
    PermissionNameEnum.dlpPolicy
  );
  const { isVisible, onClose, initialState, onSave } = props;
  const { t } = useTranslation();
  const getExpressionList = useDlpTemplateDetailStore(
    (s) => s.getExpressionList
  );
  const getKeyWordList = useDlpTemplateDetailStore((s) => s.getKeyWordList);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const handleSubmit = React.useCallback(
    async (values: DlpTemplateDetail, actions: any) => {
      console.log('onsubmit:', values, actions);
      try {
        await onSave(values);
        onClose();
      } catch (error) {
        console.error(error);
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
      }
    },
    [onSave]
  );
  useEffect(() => {
    getExpressionList();
    getKeyWordList();
  }, []);
  useWhyDidYouUpdate('MalwareScanning DlpTemplateModal', props);

  return (
    <Formik
      initialValues={initialState}
      enableReinitialize
      onSubmit={handleSubmit}
      validate={(values) => {
        const errors: any = {};
        const { dpTemplateName } = values;
        if (!dpTemplateName.trim()) {
          errors.dpTemplateName = t('policy.dlp.error.templateNameEmpty');
        }
        return errors;
      }}
    >
      {(props: FormikProps<any>) => (
        <Form>
          <Modal
            ensureFocus={true}
            autoFocus={false}
            closeOnEsc={true}
            closeOnOutsideClick={false}
            isClosable={true}
            isOpen={isVisible}
            onClose={onClose}
            size="lg"
          >
            <ModalOverlay opacity={0.9} />
            <ModalContent backgroundColor={colorStyle.background.secondary}>
              <ModalHeader>
                {initialState.cfgIndex
                  ? t('policy.modal.complianceTemplate.editTitle')
                  : t('policy.modal.complianceTemplate.addTitle')}
              </ModalHeader>
              <ModalBody>
                <Flex direction="column">
                  <Flex mb="16px" direction="column">
                    <TitleLabel
                      title={t(
                        'policy.modal.complianceTemplate.basicProperties'
                      )}
                      fontSize="18px"
                      lineHeight="24px"
                    />
                  </Flex>
                  <Stack mb="16px" direction="column" gap="16px">
                    <InputFormik
                      name="dpTemplateName"
                      label={t('common.label.enterName')}
                      required
                    />
                    <InputFormik
                      name="dpTemplateDesc"
                      label={t('common.label.description')}
                    />
                  </Stack>
                  <Divider mt="10px" mb="10px" />
                  <ConditionStatement />
                  <TemplateDefinition name="template.matchRule" />
                </Flex>
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="primary"
                  minWidth="20x"
                  type="submit"
                  onClick={(e: any) => props.handleSubmit(e)}
                  disabled={
                    initialState?.dpTemplateBuiltin ===
                      DpBuiltinEnum.Predefined || !dlpEditPermission
                  }
                >
                  {t('common.button.save')}
                </Button>
                <Space width="2x" />
                <Button minWidth="20x" onClick={onClose}>
                  {t('common.button.cancel')}
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Form>
      )}
    </Formik>
  );
});

export default DlpTemplateModal;
// const DlpTemplateModalWithStore = (props: DlpTemplateModalProps) => {
//   return (
//     <DlpTemplateDetailProvider>
//       <DlpTemplateModal {...props} />
//     </DlpTemplateDetailProvider>
//   );
// };
// export default React.memo(DlpTemplateModalWithStore);
